import { request } from '@/utils/request'

/**
 * 账号管理
 */

// 列表
export const getUserList = (data) => {
	return request({
		url: '/user/getUserList',
		method: 'post',
		data: {
			data
		}
	})
}

// 获取企业员工
export const getUserListByPid = (data) => {
	return request({
		url: '/user/getUserListByPid',
		method: 'post',
		data: {
			data
		}
	})
}


// 获取角色
export const getAllRoles = (data) => {
	return request({
		url: '/user/getAllRoles',
		method: 'post',
		data: {
			data
		}
	})
}


// 添加账号
export const addUserItem = (data) => {
	return request({
		url: '/user/addUserItem',
		method: 'post',
		data: {
			data
		}
	})
}

// 获取详情
export const getUserItem = (id) => {
	return request({
		url: '/user/getUserItem',
		method: 'post',
		data: {
			data: { id }
		}
	})
}

// 修改账号
export const saveUserItem = (data) => {
	return request({
		url: '/user/saveUserItem',
		method: 'post',
		data: {
			data
		}
	})
}

// 删除账号
export const delUserItem = (mobile) => {
	return request({
		url: '/user/delUserItem',
		method: 'post',
		data: {
			data: {
				app_name: 'compnay',
				mobile
			}
		}
	})
}





/**
 * 角色信息
 */
//获取列表
export const getRolesList = (data) => {
	return request({
		url: '/roles/getRolesList',
		method: 'post',
		data: {
			data
		}
	})
}

